import { Component, OnInit, Inject } from '@angular/core';
import { Validators, UntypedFormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ComponentBase } from '@definitiv-packages/angular-dba-library';
import { Document, DocumentService } from '@definitiv-packages/angular-documents-library';

import { DocumentDataType, ProjectLanguage, ServiceModel, ServiceService } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-close-service',
  templateUrl: './close-service.component.html',
  styleUrls: ['./close-service.component.scss'],
  standalone: false
})
export class CloseServiceComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public maxDate = new Date();
  public followUp: boolean = false;
  public documentList: Document[] = [];
  //#endregion

  private datumAbgeschlossenControl: FormControl<Date | null> = new FormControl(new Date(), [Validators.required]);
  private berichtControl: FormControl<string | null> = new FormControl(null);
  private datumFolgeterminControl: FormControl<Date | null> = new FormControl(null);

  public formGroup = new UntypedFormGroup({
    datumAbgeschlossenControl: this.datumAbgeschlossenControl,
    berichtControl: this.berichtControl,
    datumFolgeterminControl: this.datumFolgeterminControl
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceModel,
    public dialogRef: MatDialogRef<CloseServiceComponent>,
    private serviceService: ServiceService,
    private documentService: DocumentService
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      this.documentList = await this.documentService.getFilteredList({ DataTypeID: DocumentDataType.Service, DataID: this.data.ServiceID });

      if (this.data.Intervall) {
        this.followUp = true;
        var newDate = new Date();
        var Folgetermin = new Date(newDate.setMonth(newDate.getMonth() + this.data.Intervall));
        this.datumFolgeterminControl.setValue(Folgetermin);
      } else {
        this.datumAbgeschlossenControl.disable;
      }
    } finally {
      this.loading = false;
    }
  }

  public async Save(): Promise<void> {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) return;

    var service = this.data;

    var Folgetermin = this.followUp ? this.datumFolgeterminControl.value : null;

    try {
      this.loading = true;
      var result = await this.serviceService.close(service, Folgetermin);
      if (!result) return;

      await this.documentService.setList(DocumentDataType.Service, this.data.ServiceID, this.documentList);
      this.dialogRef.close(result);
    } finally {
      this.loading = false;
    }
  }
}
